import Swiper from 'swiper';
import SwiperCore, { Navigation } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation]);

export default class CollectionBannerCarousel {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * collections banner carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.slides = this.sliderElement.querySelector('.js-slide');
        this.slidesLength = this.sliderElement.querySelectorAll('.js-slide').length;
        this.init();
    }

    init() {
        new Swiper(this.sliderElement, {
            slidesPerView: 1.5,
            spaceBetween: 8,
            threshold: 10,
            speed: 400,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev,
                lockClass: 'swiper-button-lock--visible'
            },
            breakpoints: {
                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 14
                },
                1024: {
                    slidesPerView: this.slidesLength > 4 ? 4.5 : 4,
                    spaceBetween: 14,
                    slidesOffsetAfter: this.slidesLength > 4 ? 55 : 0,
                    slidesOffsetBefore: this.slidesLength > 4 ? 55 : 0
                },
                1280: {
                    slidesPerView: this.slidesLength > 5 ? 5.5 : 5,
                    spaceBetween: 14,
                    slidesOffsetAfter: this.slidesLength > 5 ? 55 : 0,
                    slidesOffsetBefore: this.slidesLength > 5 ? 55 : 0
                }
            }
        });

        // Hide carousel arrows if slider length too small
        if ((window.innerWidth > 1280 && this.slidesLength > 5) || (window.innerWidth > 1024 && window.innerWidth < 1280 && this.slidesLength > 4)) {
            this.arrowNext.parentElement.classList.remove('hidden');
            this.arrowPrev.parentElement.classList.remove('hidden');
        } else {
            this.arrowNext.parentElement.classList.add('hidden');
            this.arrowPrev.parentElement.classList.add('hidden');
        }
    }
}
